import { render, staticRenderFns } from "./PlantRegister.vue?vue&type=template&id=46c51286&scoped=true&"
import script from "./PlantRegister.vue?vue&type=script&lang=js&"
export * from "./PlantRegister.vue?vue&type=script&lang=js&"
import style0 from "./PlantRegister.vue?vue&type=style&index=0&id=46c51286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c51286",
  null
  
)

export default component.exports